















import { Component, Emit, Vue } from 'vue-property-decorator'

declare const Dynamsoft: any

@Component
export default class DynamsoftBarcodeScanner extends Vue {

  public $refs!: {
    container: HTMLElement
  }

  public error: string = ''
  public barcodeScanner: any = null

  public async mounted() {
    try {
      const config = {
        UIElement: this.$refs.container,
        onUnduplicatedRead: this.scanned.bind(this)
      }

      const scanner = await Dynamsoft.BarcodeScanner.createInstance(config)
      await this.initScanner(scanner)
    } catch (err) {
      console.log(err);
    }
  }

  @Emit('scanned')
  public scanned(barcode: string) {
    if (this.barcodeScanner) {
      this.barcodeScanner.pause()
    }
  }

  public async initScanner(scanner: any) {
    await this.updateSettings(scanner)

    this.barcodeScanner = scanner
    this.startScanning()
  }

  public startScanning() {
    if (this.barcodeScanner) {
      this.barcodeScanner.show()
    }
  }

  public stopScanning() {
    if (this.barcodeScanner) {
      this.barcodeScanner.hide()
    }
  }

  public async resetScanner() {
    if (this.barcodeScanner) {
      try {
        await this.barcodeScanner.play()
      } catch (e) {
        console.log(e)
      }
    }
  }

  protected async updateSettings(scanner: any) {
    const settings = await scanner.getRuntimeSettings()

    settings.localizationModes = [
      Dynamsoft.EnumLocalizationMode.LM_CONNECTED_BLOCKS,
      Dynamsoft.EnumLocalizationMode.LM_SCAN_DIRECTLY,
      Dynamsoft.EnumLocalizationMode.LM_LINES, 0, 0, 0, 0, 0
    ]
    settings.deblurLevel = 0
    settings.minResultConfidence = 30

    await scanner.updateRuntimeSettings(settings)

    const scanSettings = await scanner.getScanSettings()
    scanSettings.duplicateForgetTime = 500
    await scanner.updateScanSettings(scanSettings)
  }
}
